/**
 * @generated SignedSource<<3117d88feba1886555ce61e4cd8993af>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UserCreateInput = {
  group: string;
  name: string;
};
export type UserCreateDialog_userCreateMutation$variables = {
  input: UserCreateInput;
};
export type UserCreateDialog_userCreateMutation$data = {
  readonly userCreate: {
    readonly id: string;
  };
};
export type UserCreateDialog_userCreateMutation = {
  response: UserCreateDialog_userCreateMutation$data;
  variables: UserCreateDialog_userCreateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "User",
    "kind": "LinkedField",
    "name": "userCreate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UserCreateDialog_userCreateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UserCreateDialog_userCreateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "b33baeef587a2c4b5a5178ff7ef49cee",
    "id": null,
    "metadata": {},
    "name": "UserCreateDialog_userCreateMutation",
    "operationKind": "mutation",
    "text": "mutation UserCreateDialog_userCreateMutation(\n  $input: UserCreateInput!\n) {\n  userCreate(input: $input) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "2a09907aa4964e1e9f274285c81a6573";

export default node;
